import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../../layouts/dashboard/default"));
const AllMenus = lazy(() => import("../pages/all-menus"));

export const MenuManagement = [
  {
    path: "/master-management/menu",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "all",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllMenus />
          </Suspense>
        ),
      },
    ],
  },
];
